import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        background: 'black',
        '@media (min-width:600px)': {
            minWidth: 590,
        },
    },
    name: {
        fontSize: '1.2rem',
        textTransform: "uppercase",
        color: 'whitesmoke',
        textAlign: 'center',
    },
    title: {
        marginBottom: 12,
        color: 'orange',
        textAlign: 'center',
        borderBottomStyle: 'dotted',
        lineHeight: 3,
    },
    content: {
        color: '#ccc',
        textAlign: 'center',
        fontFamily: 'Architects Daughter',
        fontSize: '1.2rem',
        padding: 10,
        '@media (min-width:600px)': {
            width: 590,
            fontSize: '1.5rem',
        },
    },
});

const TestimonialCard = ({ name, designation, testimonial }) => {
    const classes = useStyles();

    return (
        <Card className={classes.root} variant="outlined">
            <CardContent>
                <Typography className={classes.name} component="h2">
                    {name}
                </Typography>
                <Typography className={classes.title}>
                    {designation}
                </Typography>
                <Typography className={classes.content} variant="body2" component="p">
                    {testimonial}
                </Typography>
            </CardContent>
        </Card>
    );
}

export default TestimonialCard

